import { render, staticRenderFns } from "./addToBasket.vue?vue&type=template&id=57381d02&scoped=true"
import script from "./addToBasket.vue?vue&type=script&lang=js"
export * from "./addToBasket.vue?vue&type=script&lang=js"
import style0 from "./addToBasket.vue?vue&type=style&index=0&id=57381d02&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57381d02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/dvl/tthomsen/compiere-all/pharmanord2011/template/webapps/productWidget/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57381d02')) {
      api.createRecord('57381d02', component.options)
    } else {
      api.reload('57381d02', component.options)
    }
    module.hot.accept("./addToBasket.vue?vue&type=template&id=57381d02&scoped=true", function () {
      api.rerender('57381d02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/addToBasket.vue"
export default component.exports